import React from 'react'
import hoistNonReactStatics from 'hoist-non-react-statics'

import getInjectors from './reducerInjectors'
import { store } from '../reduxStoreHelper'

/**
 * Dynamically injects a reducer
 */
export default ({ key, reducer }) =>
  (WrappedComponent) => {
    class ReducerInjector extends React.Component {
      static WrappedComponent = WrappedComponent
      static displayName = `withReducer(${
        WrappedComponent.displayName || WrappedComponent.name || 'Component'
      })`

      constructor(props) {
        super(props)
        this.injectors = getInjectors(store)
        this.injectors.injectReducer(key, reducer)
      }

      render() {
        return <WrappedComponent {...this.props} />
      }
    }

    return hoistNonReactStatics(ReducerInjector, WrappedComponent)
  }
